// extracted by mini-css-extract-plugin
module.exports = {"dots-icon":"DotsDropdown_dots-icon__1yDCF","rotated":"DotsDropdown_rotated__2VSN5"};